module.exports = __webpack_public_path__ + "static/img/mb-02.bf948ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/x3/mb-02.jpg
// module id = CQ7g
// module chunks = 1